import { z } from 'zod';
export const createShiftSchema = z.object({
    opposition_id: z.string().uuid('ID de oposición inválido'),
    name: z.string().min(2, 'El nombre debe tener al menos 2 caracteres').max(100),
    schedule_description: z.string().max(300).optional(),
    max_students: z.number().int().positive('El máximo de alumnos debe ser positivo').optional(),
});
export const updateShiftSchema = createShiftSchema.partial().omit({ opposition_id: true });
//# sourceMappingURL=shift.schema.js.map